export const getAddressByTypeCodeLegacy = (holder, typeCode) =>
    holder.get("addresses") && holder.get("addresses").find((address) => address.get("addressTypeCode") === typeCode);
